export const statusDate = (status) => {
    if (!status || status.date === undefined || !status.date) return '';
    const array = status.date.split('-');
    const m = undefined !== array[1] ? array[1] - 1 : false;
    if (!m || m < 0) return array[0];
    const date = new Date(array[0], array[1]);
    const year = date.getFullYear();
    const month = date.toLocaleString('default', { month: 'long' });
    return year + ' ' + month;
};